export default function SunsetRollIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect width="64" height="64" rx="12" fill="#14042a" />
      <path d="M24 14h16l22 46H2z" fill="#3a0f4a" stroke="#ff4fd8" strokeWidth="2" />
      <path d="M29 14l-9 46M35 14l9 46M16 32h32M10 46h44M20 22h24" stroke="#ff4fd8" strokeWidth="1.5" opacity="0.8" />
      <path d="M38 24h7l2 7h-7z" fill="#ff2a44" />
      <circle cx="28" cy="40" r="8" fill="#ffcf3d" stroke="#ff4fd8" strokeWidth="2" />
      <path d="M21 41q7 4 14 0" stroke="#ff4fd8" strokeWidth="2" fill="none" />
    </svg>
  );
}
